import { proxy, useSnapshot } from 'valtio';

export type OverlayStatus = 'OPEN' | 'CLOSE';

interface SearchState {
  overlayStatus?: OverlayStatus;
  page: number;
}

export const searchStateActions = {
  changeOverlayStatus: (status: OverlayStatus) => {
    searchState.overlayStatus = status;
    if (status === 'CLOSE') {
      searchState.page = 1;
    }
  },

  addOverlayPage: () => {
    searchState.page = (searchState.page ?? 1) + 1;
  },

  toggleOverlayStatus: () => {
    if (searchState.overlayStatus === 'CLOSE') {
      searchState.overlayStatus = 'OPEN';
    } else {
      searchState.overlayStatus = 'CLOSE';
      searchState.page = 1;
    }
  },
};

export const searchState = proxy<SearchState>({
  overlayStatus: 'CLOSE',
  page: 1,
});

export const useSearchState = () => useSnapshot(searchState);
